import React from 'react';
import { Star } from 'lucide-react';
import { Divider } from './ui/Divider';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Sarah M.',
    age: 42,
    location: 'Austin, TX',
    quote: 'I was waking up at 3 AM every night, drenched in sweat and unable to go back to sleep. By day 5 of the protocol, I slept through the night for the first time in years. My energy is finally back.'
  }, {
    name: 'Diana R.',
    age: 56,
    location: 'Portland, OR',
    quote: 'The brain fog was so bad I thought I was losing my mind. This protocol cleared it up in less than two weeks. I finally feel like myself again—sharp, focused, and present.'
  }, {
    name: 'Jennifer K.',
    age: 38,
    location: 'Chicago, IL',
    quote: "I was doing everything 'right' but still felt bloated and heavy. The estrogen detox steps were a game changer. It's incredibly simple to follow, and my jeans finally fit comfortably again."
  }];
  return <section className="bg-cream py-24 px-6" data-id="element-96">
      <div className="max-w-6xl mx-auto" data-id="element-97">
        <div className="text-center mb-16" data-id="element-98">
          <h2 className="text-4xl md:text-5xl mb-6" data-id="element-99">
            Real Women. Real Results.
          </h2>
          <Divider data-id="element-100" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-101">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-2xl border border-sage/10 shadow-sm relative flex flex-col" data-id="element-102">
              <div className="text-olive-gold/20 absolute top-6 right-6 font-heading text-6xl leading-none" data-id="element-103">
                "
              </div>
              <div className="flex gap-1 mb-6" data-id="element-104">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-olive-gold text-olive-gold" data-id="element-105" />)}
              </div>
              <p className="text-warm-dark/80 leading-relaxed mb-8 relative z-10 flex-grow" data-id="element-106">
                "{testimonial.quote}"
              </p>
              <div className="mt-auto pt-4 border-t border-sage/10" data-id="element-107">
                <p className="font-heading text-xl font-bold text-warm-dark" data-id="element-108">
                  {testimonial.name}, {testimonial.age}
                </p>
                <p className="text-sm text-warm-dark/60 uppercase tracking-wider mt-1" data-id="element-109">
                  {testimonial.location}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}